// @ts-nocheck
// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

export enum IndexType {
  Text = 0,
  Image = 1,
  Audio = 2,
  PDF = 3,
  Handwriting = 4
}
